// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Theme_root_external {
  /* Общие переменные для переиспользования */
  --control-font-family: 'SBSansText', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;
  --display-font-family: 'SBSansDisplay', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;
  --interface-font-family: 'SBSansInterface', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;
  --interface-caps-font-family: 'SBSansInterfaceCaps', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;

  /* TextInput */
  /* в дизайне только один размер - l. Размеры m и s заложили на всякий случай */
  --textinput-size-l-height: 48px;
  --textinput-size-m-height: 44px;
  --textinput-size-s-height: 36px;

  --textinput-font-family: var(--control-font-family);
  --textinput-disable-opacity: 0.6;

  --textinput-size-l-icon-width: var(--textinput-size-l-height);
  --textinput-size-l-icon-height: var(--textinput-size-l-height);
  --textinput-size-l-font-size: 0.875rem;
  --textinput-size-l-line-height: 1.28;
  --textinput-size-l-font-size-label-active: 0.75rem;
  --textinput-size-l-line-height-label-active: 1.25;
  --textinput-size-l-font-size-hint: 0.875rem;
  --textinput-size-l-line-height-hint: 1.42;
  --textinput-size-l-font-size-label: 0.875rem;
  --textinput-size-l-line-height-label: 1.42;
  --textinput-size-l-font-size-counter: 0.875rem;
  --textinput-size-l-line-height-counter: 1.42;
  --textinput-size-l-font-size-required: 0.5rem;

  --textinput-size-m-icon-width: var(--textinput-size-m-height);
  --textinput-size-m-icon-height: var(--textinput-size-m-height);
  --textinput-size-m-font-size: 0.812rem;
  --textinput-size-m-line-height: 1.3;
  --textinput-size-m-font-size-label-active: 0.687rem;
  --textinput-size-m-line-height-label-active: 1.27;
  --textinput-size-m-font-size-hint: 0.725rem;
  --textinput-size-m-line-height-hint: 1.3;
  --textinput-size-m-font-size-label: 0.725rem;
  --textinput-size-m-line-height-label: 1.3;
  --textinput-size-m-font-size-counter: 0.725rem;
  --textinput-size-m-line-height-counter: 1.3;
  --textinput-size-m-font-size-required: 0.4rem;

  --textinput-size-s-icon-width: var(--textinput-size-s-height);
  --textinput-size-s-icon-height: var(--textinput-size-s-height);
  --textinput-size-s-font-size: 0.75rem;
  --textinput-size-s-line-height: 1.33;
  --textinput-size-s-font-size-label-active: 0.625rem;
  --textinput-size-s-line-height-label-active: 1.3;
  --textinput-size-s-font-size-hint: 0.675rem;
  --textinput-size-s-line-height-hint: 1.2;
  --textinput-size-s-font-size-label: 0.675rem;
  --textinput-size-s-line-height-label: 1.2;
  --textinput-size-s-font-size-counter: 0.675rem;
  --textinput-size-s-line-height-counter: 1.2;
  --textinput-size-s-font-size-required: 0.3rem;

  /* Title */
  --title-h1-font-size: 1.5rem;
  --title-h1-line-height: 1.25;
  --title-h2-font-size: 1.375rem;
  --title-h2-line-height: 1.27;
  --title-h3-font-size: 1.25rem;
  --title-h3-line-height: 1.2;
  --title-h4-font-size: 1rem;
  --title-h4-line-height: 1.25;
  --title-h5-font-size: 0.875rem;
  --title-h5-line-height: 1.28;
  --title-h6-font-size: 0.75rem;
  --title-h6-line-height: 1;
  --title-font-family: var(--display-font-family);
  --typography-font-family: var(--control-font-family);

  /* Typography */
  --typography-p1-font-size: 16px;
  --typography-p1-line-height: 20px;
  --typography-p2-font-size: 14px;
  --typography-p2-line-height: 18px;
  --typography-p3-font-size: 12px;
  --typography-p3-line-height: 15px;
  --typography-p4-font-size: 16px;
  --typography-p4-line-height: 22px;
  --typography-p-font-weight-default: 400;
  --typography-p-font-weight-strong: 700;

  /* Button */
  --button-font-family: var(--display-font-family);
  --button-border-radius: 30px;
  --button-s-size: 44px;
  --button-m-size: 56px;
  --button-l-size: 56px;
  --button-border-width: 2px;
  --button-font-size: 1.125rem;

  /* Badge */
  --badge-font-family: var(--display-font-family);
  --badge-font-size: 1rem;
  --badge-line-height: 0.8;
  --badge-font-weight: 400;
  --badge-l-size: 24px;
  --badge-m-size: 18px;
  --badge-s-size: 16px;

  /* TabBar */
  --tab-bar-font-family: var(--display-font-family);
  --tab-bar-font-size: 11px;
  --tab-bar-line-height: 15px;
  --tab-bar-letter-spacing: -0.02em;

  /* Tooltip */
  --tooltip-font-family: var(--control-font-family);

  /* Rating */
  --rating-font-family: var(--display-font-family);

  /* Search */
  --search-font-family: var(--control-font-family);
  --search-background-color-normal: #f6f7fa;
  --search-background-color-pressed: #dee1eb;
  --search-placeholder-color-normal: #576875;
  --search-placeholder-color-focused: #9199a3;
  --search-action-button-color: #9199a3;
  --search-action-button-background-color-pressed: #dee1eb;
  --search-icon-color: #8168f0;

  /* Tag */
  --tag-font-family: var(--control-font-family);
  --tag-height: 2.25rem;
  --tag-border-radius: 1rem;
  --tag-font-size: 0.875rem;
  --tag-line-height: 1.125rem;

  /* Breadcrumbs */
  --breadcrumbs-font-size: 0.875rem;
  --breadcrumbs-spacing-x-separator: 1rem;
  --breadcrumbs-font-weight-current: 600;

  /* RadioButton */
  --radio-button-size: 1.5rem;
  --radio-button-border-width-active: calc(var(--radio-button-size) / 2);

  /* Notification */
  --notification-border-radius: 16px;
  --notification-shadow: 4px 8px 15px rgba(0, 0, 0, 0.05);

  /* Price */
  --price-current-value-font-size: 1rem;
  --price-current-value-line-heigth: 1rem;
  --price-old-value-font-size: 0.875rem;
  --price-old-value-line-heigth: 0.875rem;
  --price-current-value-font-size-l: 1.375rem;
  --price-current-value-line-heigth-l: 1.375rem;
  --price-old-value-font-size-l: 1rem;
  --price-old-value-line-heigth-l: 1rem;

  /* ProductThumbnail */
  --product-thumbnail-height-default: 152px;

  /* ProductCard */
  --product-card-font-size: 0.875rem;
  --product-card-line-height: 1rem;
  --product-card-font-size-row: 1rem;
  --product-card-line-height-row: 1.25rem;
  --product-card-font-size-notification: 1rem;
  --product-card-line-height-notification: 1.2rem;
  --product-card-font-size-extra-link: 0.75rem;
  --product-card-line-height-extra-link: 0.875rem;

  /* Banner */
  --banner-font-size: 0.875rem;
  --banner-line-height: 1.125rem;

  /* Textarea */
  --textarea-size-m-minWidth: 328px;
  --textarea-size-m-minHeight: 101px;
  --textarea-size-m-spaceAll: 23px 12px 6px 16px;
  --textarea-size-m-fontSize: 0.875rem;
  --textarea-font-family: var(--control-font-family);
  --textarea-padding-control: 0 9px 0 0;
  --textarea-hint-fz: 0.875rem;

  /* PinInput */
  --pininput-font-size-item: 1.8rem;
  --pininput-line-height-item: 1.62;
  --pininput-font-size-hint: 0.875rem;
  --pininput-line-height-hint: 1.28;

  /* PharmacyCard */
  --pharmacy-card-font-size: 0.875rem;
  --pharmacy-card-line-height: 1.28;
  --pharmacy-card-font-size-address: 1rem;
  --pharmacy-card-line-height-address: 1.25;

  /* Checkbox */
  --checkbox-box-size: 24px;
  --checkbox-box-border-active-width: 12px;

  /* ProgressIndicator */
  --progress-indicator-font-size: 1rem;
  --progress-indicator-line-height: 1.5;
  --progress-indicator-font-size-status: 0.875rem;
  --progress-indicator-line-height-status: 1.28;

  /* MessageBubble */
  --message-bubble-font-size: 0.875rem;
  --message-bubble-line-height: 1.28;
  --message-bubble-font-size-time: 0.75rem;
  --message-bubble-line-height-time: 1;

  /* Tabs */
  --tabs-container-border-radius-squared: 8px;
  --tabs-container-border-radius-rounded: 2rem;
  --tabs-tab-squared-border-radius: 6px;
  --tabs-tab-rounded-border-radius: 2rem;
  --tabs-tab-font-size: 0.875rem;
  --tabs-tab-line-height: 1.28;
  --tabs-tab-font-weight: 600;

  /* Adress */
  --address-font-size: 0.875rem;
  --address-line-height: 1.285;
  --address-font-size-label: 1.25rem;
  --address-line-height-label: 1.2;

  /* Calendar */
  --calendar-font-size: 1rem;

  /* FieldText */
  --field-text-label-top: 18px;
  --field-text-label-top-has-focus: 8px;
  --field-text-m-label-top: 15px;
  --field-text-m-label-top-has-focus: 6px;
  --field-text-label-font: var(--control-font-family);
  --field-text-label-font-size: 1em;
  --field-text-m-label-font-size: 0.875em;
  --field-text-independent-label-font-size: 0.875em;
  --field-text-m-independent-label-font-size: 0.75em;
  --field-text-label-stuck-textarea-padding-top: 24px;
  --field-text-label-transition: all 0.15s linear;
  --field-text-counter-font: var(--control-font-family);
  --field-text-counter-font-size: 0.75em;
  --field-text-counter-lineheight: 1.25;

  --field-text-label-is-stuck-left: 8px;
  --field-text-label-is-stuck-font-size: 0.75em;
  --field-text-label-is-stuck-transform: translateY(-10px);

  --field-text-is-multiline-label-top: 16px;
  --field-text-is-multiline-label-top-has-focus: 16px;

  /* InputText */
  --input-text-height: 56px;
  --input-text-m-height: 48px;
  --input-text-min-height: 101px;
  --input-text-input-padding: 0 16px;
  --input-text-input-padding-focus: 24px 16px 5px;
  --input-text-textarea-padding: 15px 16px;
  --input-text-textarea-padding-focus: 35px 16px 6px;
  --input-text-textarea-padding-top: 15px;
  --input-text-font: var(--control-font-family);
  --input-text-font-size: 1em;
  --input-text-m-font-size: 0.875em;
  --input-text-addon-after-padding-right: 4px;
  --input-text-addon-after-buttons-margin-left: 8px;
  --input-text-textarea-min-height: 160px;

  /* List */
  --list-border-radius: 16px;

  /* ListItem */
  --listitem-border-radius: var(--list-border-radius);

  /* Pagination */
  --pagination-container-margin: 0.4em;
  --pagination-arrow-border: none;
  --pagination-item-border-radius: 2.4em;
  --pagination-item-border: none;
  --pagination-item-inline-margin: 0.6em;
  --pagination-item-inline-padding: 0.8em;
  --pagination-item-block-padding: 0.6em;
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .Theme_root_external {
    /* Button */
    --button-s-size: 32px;
    --button-m-size: 48px;
    --button-l-size: 48px;
    --button-border-width: 1px;

    --badge-font-size: 0.75rem;
    --badge-font-weight: 600;

    /* InputText */
    --input-text-height: 48px;
    --input-text-textarea-min-height: 120px;
    --input-text-font-size: 0.875em;

    /* FieldText */
    --field-text-label-top: 16px;
    --field-text-label-top-has-focus: 5px;
    --field-text-label-font-size: .875em;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Theme/presets/external/root.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,6FAA6F;EAC7F,gGAAgG;EAChG,oGAAoG;EACpG,6GAA6G;;EAE7G,cAAc;EACd,8EAA8E;EAC9E,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;;EAE/B,mDAAmD;EACnD,gCAAgC;;EAEhC,6DAA6D;EAC7D,8DAA8D;EAC9D,sCAAsC;EACtC,oCAAoC;EACpC,kDAAkD;EAClD,iDAAiD;EACjD,2CAA2C;EAC3C,yCAAyC;EACzC,4CAA4C;EAC5C,0CAA0C;EAC1C,8CAA8C;EAC9C,4CAA4C;EAC5C,6CAA6C;;EAE7C,6DAA6D;EAC7D,8DAA8D;EAC9D,sCAAsC;EACtC,mCAAmC;EACnC,mDAAmD;EACnD,iDAAiD;EACjD,2CAA2C;EAC3C,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;EACzC,8CAA8C;EAC9C,2CAA2C;EAC3C,6CAA6C;;EAE7C,6DAA6D;EAC7D,8DAA8D;EAC9D,qCAAqC;EACrC,oCAAoC;EACpC,mDAAmD;EACnD,gDAAgD;EAChD,2CAA2C;EAC3C,wCAAwC;EACxC,4CAA4C;EAC5C,yCAAyC;EACzC,8CAA8C;EAC9C,2CAA2C;EAC3C,6CAA6C;;EAE7C,UAAU;EACV,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,+CAA+C;EAC/C,oDAAoD;;EAEpD,eAAe;EACf,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;EAC/B,iCAAiC;EACjC,uCAAuC;EACvC,sCAAsC;;EAEtC,WAAW;EACX,gDAAgD;EAChD,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;;EAE5B,UAAU;EACV,+CAA+C;EAC/C,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,WAAW;EACX,iDAAiD;EACjD,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;;EAEjC,YAAY;EACZ,iDAAiD;;EAEjD,WAAW;EACX,gDAAgD;;EAEhD,WAAW;EACX,gDAAgD;EAChD,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,qCAAqC;EACrC,wDAAwD;EACxD,4BAA4B;;EAE5B,QAAQ;EACR,6CAA6C;EAC7C,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,gBAAgB;EAChB,iCAAiC;EACjC,uCAAuC;EACvC,sCAAsC;;EAEtC,gBAAgB;EAChB,2BAA2B;EAC3B,sEAAsE;;EAEtE,iBAAiB;EACjB,kCAAkC;EAClC,uDAAuD;;EAEvD,UAAU;EACV,qCAAqC;EACrC,uCAAuC;EACvC,qCAAqC;EACrC,uCAAuC;EACvC,2CAA2C;EAC3C,6CAA6C;EAC7C,mCAAmC;EACnC,qCAAqC;;EAErC,qBAAqB;EACrB,yCAAyC;;EAEzC,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,kCAAkC;EAClC,uCAAuC;EACvC,2CAA2C;EAC3C,+CAA+C;EAC/C,4CAA4C;EAC5C,+CAA+C;;EAE/C,WAAW;EACX,4BAA4B;EAC5B,8BAA8B;;EAE9B,aAAa;EACb,iCAAiC;EACjC,kCAAkC;EAClC,8CAA8C;EAC9C,oCAAoC;EACpC,kDAAkD;EAClD,qCAAqC;EACrC,4BAA4B;;EAE5B,aAAa;EACb,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;;EAEjC,iBAAiB;EACjB,mCAAmC;EACnC,iCAAiC;EACjC,uCAAuC;EACvC,yCAAyC;;EAEzC,aAAa;EACb,yBAAyB;EACzB,wCAAwC;;EAExC,sBAAsB;EACtB,oCAAoC;EACpC,qCAAqC;EACrC,+CAA+C;EAC/C,6CAA6C;;EAE7C,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,wCAAwC;EACxC,oCAAoC;;EAEpC,SAAS;EACT,2CAA2C;EAC3C,4CAA4C;EAC5C,qCAAqC;EACrC,sCAAsC;EACtC,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;;EAE3B,WAAW;EACX,6BAA6B;EAC7B,4BAA4B;EAC5B,kCAAkC;EAClC,gCAAgC;;EAEhC,aAAa;EACb,0BAA0B;;EAE1B,cAAc;EACd,4BAA4B;EAC5B,qCAAqC;EACrC,8BAA8B;EAC9B,uCAAuC;EACvC,mDAAmD;EACnD,iCAAiC;EACjC,uCAAuC;EACvC,iDAAiD;EACjD,kDAAkD;EAClD,mDAAmD;EACnD,+CAA+C;EAC/C,qDAAqD;EACrD,sCAAsC;EACtC,qCAAqC;;EAErC,qCAAqC;EACrC,6CAA6C;EAC7C,wDAAwD;;EAExD,yCAAyC;EACzC,mDAAmD;;EAEnD,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,+CAA+C;EAC/C,wCAAwC;EACxC,kDAAkD;EAClD,uCAAuC;EACvC,6CAA6C;EAC7C,2BAA2B;EAC3B,iCAAiC;EACjC,2CAA2C;EAC3C,iDAAiD;EACjD,uCAAuC;;EAEvC,SAAS;EACT,0BAA0B;;EAE1B,aAAa;EACb,mDAAmD;;EAEnD,eAAe;EACf,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;EACtC,8BAA8B;EAC9B,sCAAsC;EACtC,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE;IACE,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,0BAA0B;;IAE1B,0BAA0B;IAC1B,wBAAwB;;IAExB,cAAc;IACd,yBAAyB;IACzB,uCAAuC;IACvC,+BAA+B;;IAE/B,cAAc;IACd,4BAA4B;IAC5B,qCAAqC;IACrC,oCAAoC;EACtC;AACF","sourcesContent":[".Theme_root_external {\n  /* Общие переменные для переиспользования */\n  --control-font-family: 'SBSansText', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;\n  --display-font-family: 'SBSansDisplay', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;\n  --interface-font-family: 'SBSansInterface', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;\n  --interface-caps-font-family: 'SBSansInterfaceCaps', opensans, 'Helvetica Neue', helvetica, arial, sans-serif;\n\n  /* TextInput */\n  /* в дизайне только один размер - l. Размеры m и s заложили на всякий случай */\n  --textinput-size-l-height: 48px;\n  --textinput-size-m-height: 44px;\n  --textinput-size-s-height: 36px;\n\n  --textinput-font-family: var(--control-font-family);\n  --textinput-disable-opacity: 0.6;\n\n  --textinput-size-l-icon-width: var(--textinput-size-l-height);\n  --textinput-size-l-icon-height: var(--textinput-size-l-height);\n  --textinput-size-l-font-size: 0.875rem;\n  --textinput-size-l-line-height: 1.28;\n  --textinput-size-l-font-size-label-active: 0.75rem;\n  --textinput-size-l-line-height-label-active: 1.25;\n  --textinput-size-l-font-size-hint: 0.875rem;\n  --textinput-size-l-line-height-hint: 1.42;\n  --textinput-size-l-font-size-label: 0.875rem;\n  --textinput-size-l-line-height-label: 1.42;\n  --textinput-size-l-font-size-counter: 0.875rem;\n  --textinput-size-l-line-height-counter: 1.42;\n  --textinput-size-l-font-size-required: 0.5rem;\n\n  --textinput-size-m-icon-width: var(--textinput-size-m-height);\n  --textinput-size-m-icon-height: var(--textinput-size-m-height);\n  --textinput-size-m-font-size: 0.812rem;\n  --textinput-size-m-line-height: 1.3;\n  --textinput-size-m-font-size-label-active: 0.687rem;\n  --textinput-size-m-line-height-label-active: 1.27;\n  --textinput-size-m-font-size-hint: 0.725rem;\n  --textinput-size-m-line-height-hint: 1.3;\n  --textinput-size-m-font-size-label: 0.725rem;\n  --textinput-size-m-line-height-label: 1.3;\n  --textinput-size-m-font-size-counter: 0.725rem;\n  --textinput-size-m-line-height-counter: 1.3;\n  --textinput-size-m-font-size-required: 0.4rem;\n\n  --textinput-size-s-icon-width: var(--textinput-size-s-height);\n  --textinput-size-s-icon-height: var(--textinput-size-s-height);\n  --textinput-size-s-font-size: 0.75rem;\n  --textinput-size-s-line-height: 1.33;\n  --textinput-size-s-font-size-label-active: 0.625rem;\n  --textinput-size-s-line-height-label-active: 1.3;\n  --textinput-size-s-font-size-hint: 0.675rem;\n  --textinput-size-s-line-height-hint: 1.2;\n  --textinput-size-s-font-size-label: 0.675rem;\n  --textinput-size-s-line-height-label: 1.2;\n  --textinput-size-s-font-size-counter: 0.675rem;\n  --textinput-size-s-line-height-counter: 1.2;\n  --textinput-size-s-font-size-required: 0.3rem;\n\n  /* Title */\n  --title-h1-font-size: 1.5rem;\n  --title-h1-line-height: 1.25;\n  --title-h2-font-size: 1.375rem;\n  --title-h2-line-height: 1.27;\n  --title-h3-font-size: 1.25rem;\n  --title-h3-line-height: 1.2;\n  --title-h4-font-size: 1rem;\n  --title-h4-line-height: 1.25;\n  --title-h5-font-size: 0.875rem;\n  --title-h5-line-height: 1.28;\n  --title-h6-font-size: 0.75rem;\n  --title-h6-line-height: 1;\n  --title-font-family: var(--display-font-family);\n  --typography-font-family: var(--control-font-family);\n\n  /* Typography */\n  --typography-p1-font-size: 16px;\n  --typography-p1-line-height: 20px;\n  --typography-p2-font-size: 14px;\n  --typography-p2-line-height: 18px;\n  --typography-p3-font-size: 12px;\n  --typography-p3-line-height: 15px;\n  --typography-p4-font-size: 16px;\n  --typography-p4-line-height: 22px;\n  --typography-p-font-weight-default: 400;\n  --typography-p-font-weight-strong: 700;\n\n  /* Button */\n  --button-font-family: var(--display-font-family);\n  --button-border-radius: 30px;\n  --button-s-size: 44px;\n  --button-m-size: 56px;\n  --button-l-size: 56px;\n  --button-border-width: 2px;\n  --button-font-size: 1.125rem;\n\n  /* Badge */\n  --badge-font-family: var(--display-font-family);\n  --badge-font-size: 1rem;\n  --badge-line-height: 0.8;\n  --badge-font-weight: 400;\n  --badge-l-size: 24px;\n  --badge-m-size: 18px;\n  --badge-s-size: 16px;\n\n  /* TabBar */\n  --tab-bar-font-family: var(--display-font-family);\n  --tab-bar-font-size: 11px;\n  --tab-bar-line-height: 15px;\n  --tab-bar-letter-spacing: -0.02em;\n\n  /* Tooltip */\n  --tooltip-font-family: var(--control-font-family);\n\n  /* Rating */\n  --rating-font-family: var(--display-font-family);\n\n  /* Search */\n  --search-font-family: var(--control-font-family);\n  --search-background-color-normal: #f6f7fa;\n  --search-background-color-pressed: #dee1eb;\n  --search-placeholder-color-normal: #576875;\n  --search-placeholder-color-focused: #9199a3;\n  --search-action-button-color: #9199a3;\n  --search-action-button-background-color-pressed: #dee1eb;\n  --search-icon-color: #8168f0;\n\n  /* Tag */\n  --tag-font-family: var(--control-font-family);\n  --tag-height: 2.25rem;\n  --tag-border-radius: 1rem;\n  --tag-font-size: 0.875rem;\n  --tag-line-height: 1.125rem;\n\n  /* Breadcrumbs */\n  --breadcrumbs-font-size: 0.875rem;\n  --breadcrumbs-spacing-x-separator: 1rem;\n  --breadcrumbs-font-weight-current: 600;\n\n  /* RadioButton */\n  --radio-button-size: 1.5rem;\n  --radio-button-border-width-active: calc(var(--radio-button-size) / 2);\n\n  /* Notification */\n  --notification-border-radius: 16px;\n  --notification-shadow: 4px 8px 15px rgba(0, 0, 0, 0.05);\n\n  /* Price */\n  --price-current-value-font-size: 1rem;\n  --price-current-value-line-heigth: 1rem;\n  --price-old-value-font-size: 0.875rem;\n  --price-old-value-line-heigth: 0.875rem;\n  --price-current-value-font-size-l: 1.375rem;\n  --price-current-value-line-heigth-l: 1.375rem;\n  --price-old-value-font-size-l: 1rem;\n  --price-old-value-line-heigth-l: 1rem;\n\n  /* ProductThumbnail */\n  --product-thumbnail-height-default: 152px;\n\n  /* ProductCard */\n  --product-card-font-size: 0.875rem;\n  --product-card-line-height: 1rem;\n  --product-card-font-size-row: 1rem;\n  --product-card-line-height-row: 1.25rem;\n  --product-card-font-size-notification: 1rem;\n  --product-card-line-height-notification: 1.2rem;\n  --product-card-font-size-extra-link: 0.75rem;\n  --product-card-line-height-extra-link: 0.875rem;\n\n  /* Banner */\n  --banner-font-size: 0.875rem;\n  --banner-line-height: 1.125rem;\n\n  /* Textarea */\n  --textarea-size-m-minWidth: 328px;\n  --textarea-size-m-minHeight: 101px;\n  --textarea-size-m-spaceAll: 23px 12px 6px 16px;\n  --textarea-size-m-fontSize: 0.875rem;\n  --textarea-font-family: var(--control-font-family);\n  --textarea-padding-control: 0 9px 0 0;\n  --textarea-hint-fz: 0.875rem;\n\n  /* PinInput */\n  --pininput-font-size-item: 1.8rem;\n  --pininput-line-height-item: 1.62;\n  --pininput-font-size-hint: 0.875rem;\n  --pininput-line-height-hint: 1.28;\n\n  /* PharmacyCard */\n  --pharmacy-card-font-size: 0.875rem;\n  --pharmacy-card-line-height: 1.28;\n  --pharmacy-card-font-size-address: 1rem;\n  --pharmacy-card-line-height-address: 1.25;\n\n  /* Checkbox */\n  --checkbox-box-size: 24px;\n  --checkbox-box-border-active-width: 12px;\n\n  /* ProgressIndicator */\n  --progress-indicator-font-size: 1rem;\n  --progress-indicator-line-height: 1.5;\n  --progress-indicator-font-size-status: 0.875rem;\n  --progress-indicator-line-height-status: 1.28;\n\n  /* MessageBubble */\n  --message-bubble-font-size: 0.875rem;\n  --message-bubble-line-height: 1.28;\n  --message-bubble-font-size-time: 0.75rem;\n  --message-bubble-line-height-time: 1;\n\n  /* Tabs */\n  --tabs-container-border-radius-squared: 8px;\n  --tabs-container-border-radius-rounded: 2rem;\n  --tabs-tab-squared-border-radius: 6px;\n  --tabs-tab-rounded-border-radius: 2rem;\n  --tabs-tab-font-size: 0.875rem;\n  --tabs-tab-line-height: 1.28;\n  --tabs-tab-font-weight: 600;\n\n  /* Adress */\n  --address-font-size: 0.875rem;\n  --address-line-height: 1.285;\n  --address-font-size-label: 1.25rem;\n  --address-line-height-label: 1.2;\n\n  /* Calendar */\n  --calendar-font-size: 1rem;\n\n  /* FieldText */\n  --field-text-label-top: 18px;\n  --field-text-label-top-has-focus: 8px;\n  --field-text-m-label-top: 15px;\n  --field-text-m-label-top-has-focus: 6px;\n  --field-text-label-font: var(--control-font-family);\n  --field-text-label-font-size: 1em;\n  --field-text-m-label-font-size: 0.875em;\n  --field-text-independent-label-font-size: 0.875em;\n  --field-text-m-independent-label-font-size: 0.75em;\n  --field-text-label-stuck-textarea-padding-top: 24px;\n  --field-text-label-transition: all 0.15s linear;\n  --field-text-counter-font: var(--control-font-family);\n  --field-text-counter-font-size: 0.75em;\n  --field-text-counter-lineheight: 1.25;\n\n  --field-text-label-is-stuck-left: 8px;\n  --field-text-label-is-stuck-font-size: 0.75em;\n  --field-text-label-is-stuck-transform: translateY(-10px);\n\n  --field-text-is-multiline-label-top: 16px;\n  --field-text-is-multiline-label-top-has-focus: 16px;\n\n  /* InputText */\n  --input-text-height: 56px;\n  --input-text-m-height: 48px;\n  --input-text-min-height: 101px;\n  --input-text-input-padding: 0 16px;\n  --input-text-input-padding-focus: 24px 16px 5px;\n  --input-text-textarea-padding: 15px 16px;\n  --input-text-textarea-padding-focus: 35px 16px 6px;\n  --input-text-textarea-padding-top: 15px;\n  --input-text-font: var(--control-font-family);\n  --input-text-font-size: 1em;\n  --input-text-m-font-size: 0.875em;\n  --input-text-addon-after-padding-right: 4px;\n  --input-text-addon-after-buttons-margin-left: 8px;\n  --input-text-textarea-min-height: 160px;\n\n  /* List */\n  --list-border-radius: 16px;\n\n  /* ListItem */\n  --listitem-border-radius: var(--list-border-radius);\n\n  /* Pagination */\n  --pagination-container-margin: 0.4em;\n  --pagination-arrow-border: none;\n  --pagination-item-border-radius: 2.4em;\n  --pagination-item-border: none;\n  --pagination-item-inline-margin: 0.6em;\n  --pagination-item-inline-padding: 0.8em;\n  --pagination-item-block-padding: 0.6em;\n}\n\n/* Mobile */\n@media only screen and (max-width: 768px) {\n  .Theme_root_external {\n    /* Button */\n    --button-s-size: 32px;\n    --button-m-size: 48px;\n    --button-l-size: 48px;\n    --button-border-width: 1px;\n\n    --badge-font-size: 0.75rem;\n    --badge-font-weight: 600;\n\n    /* InputText */\n    --input-text-height: 48px;\n    --input-text-textarea-min-height: 120px;\n    --input-text-font-size: 0.875em;\n\n    /* FieldText */\n    --field-text-label-top: 16px;\n    --field-text-label-top-has-focus: 5px;\n    --field-text-label-font-size: .875em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
